import { computed, reactive, readonly, toRefs } from 'vue';

import type { Limits } from '@/references/axios/auth/types';

const state = reactive<{
  limits: Limits;
}>({
  limits: {
    minOTCAmountEUR: '9999999999'
    // maxOtcAmountEur: '0.01'
  }
});

const setLimits = (newLimits: Partial<Limits>): void => {
  state.limits = {
    ...state.limits,
    ...newLimits
  };
};

const minOtcAmountEur = computed(() => {
  return state.limits.minOTCAmountEUR;
});

// const maxOtcAmountEur = computed(() => {
//   return state.limits.maxOtcAmountEur;
// });

export const useSettings = () => {
  return {
    ...toRefs(readonly(state)),
    setLimits,
    // maxOtcAmountEur,
    minOtcAmountEur
  };
};
